import { render, staticRenderFns } from "./CustomerTypologies.vue?vue&type=template&id=70249a96&"
import script from "./CustomerTypologies.vue?vue&type=script&lang=js&"
export * from "./CustomerTypologies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports